import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { LgpdService } from 'src/app/service/lgpd/lgpd.service';
import { ERRO_NUMERO_PROCESSO_SEI } from 'src/app/tools/Mensagens';

@Component({
  selector: 'representante-legal-lgpd',
  templateUrl: './representante-legal-lgpd.component.html',
  styleUrls: ['./representante-legal-lgpd.component.css']
})
export class RepresentanteLegalLgpdComponent implements OnInit {

  @Input() visualizacao: boolean
  @ViewChild('identificacaoTitular', { static: false }) identificacaoTitular;
  @ViewChild('fotoRequerente', { static: false }) fotoRequerente;
  @ViewChild('documentoLegal', { static: false }) documentoLegal;
  @Input() RGR: any[];
  @Input() CRGR: any[];
  @Input() PR: any[];

  constructor(public service: LgpdService) { }

  ngOnInit() {
    
    // Se a demanda for Recurso contra o indeferimento de acesso a dados sigilosos, 
    // o número do processo SEI deve ser obrigatório, caso contrário não será preenchido
    this.service.lgpd.get('demanda').valueChanges
      .subscribe(demanda => this.processoSEIValidator(demanda))

  }

  processoSEIValidator(demanda: string) {
    if (demanda === "Recurso contra o indeferimento de acesso a dados sigilosos") {
      this.service.lgpd.controls.numeroProcessoSEI.setValidators(Validators.required)
    }
    else {
      this.service.lgpd.controls.numeroProcessoSEI.setValidators(null)
    }
    this.service.lgpd.controls.numeroProcessoSEI.updateValueAndValidity()
  }

  validarProcessoSEI(event) {
    let numeroProcesso = ("0000000000000000000000000" + event.target.value).slice(-25)
                      //   0001390-70.2020.8.13.0000
    this.service.lgpd.get('numeroProcessoSEI').setValue(numeroProcesso)

    this.service.validarProcesso(numeroProcesso).subscribe(nProcessoSEIValido => {
      if (!nProcessoSEIValido) {
        this.service.lgpd.get('numeroProcessoSEI').setValue(null)
        alert(ERRO_NUMERO_PROCESSO_SEI)
      }
    });
  }

}
